'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _helpersWaves = require('../helpers/waves');

var _helpersWaves2 = _interopRequireDefault(_helpersWaves);

var Item = (function (_Component) {
  _inherits(Item, _Component);

  function Item() {
    _classCallCheck(this, Item);

    _get(Object.getPrototypeOf(Item.prototype), 'constructor', this).apply(this, arguments);
  }

  _createClass(Item, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      _helpersWaves2['default'].attach(_reactDom2['default'].findDOMNode(this));
    }
  }, {
    key: 'onClick',
    value: function onClick() {
      if (typeof this.context.closeMenuHandler === 'function') {
        this.context.closeMenuHandler();
      }
      if (typeof this.props.onClick === 'function') {
        this.props.onClick();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this = this;

      var _props = this.props;
      var children = _props.children;
      var className = _props.className;
      var icon = _props.icon;
      var selected = _props.selected;
      var showIcon = _props.showIcon;
      var style = _props.style;

      var iconContainer = null;
      if (showIcon) {
        var iconElement = selected ? _react2['default'].createElement(
          'svg',
          {
            fill: '#000000',
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            style: {
              position: 'relative',
              top: '4px'
            } },
          _react2['default'].createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
          _react2['default'].createElement('path', { d: 'M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z' })
        ) : icon;
        iconContainer = _react2['default'].createElement(
          'div',
          {
            style: {
              display: 'inline-block',
              width: '48px',
              lineHeight: '32px',
              fontSize: '20px'
            } },
          iconElement || ' '
        );
      }

      return _react2['default'].createElement(
        'div',
        {
          className: (0, _classnames2['default'])('menu-item', className),
          style: Object.assign({
            padding: '0 40px 0 24px',
            lineHeight: '32px',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            display: 'block'
          }, style),
          onClick: function () {
            return _this.onClick();
          } },
        iconContainer,
        _react2['default'].createElement(
          'div',
          {
            style: {
              display: 'inline-block',
              fontSize: '16px'
            } },
          children
        )
      );
    }
  }], [{
    key: 'displayName',
    value: 'Menu.Item',
    enumerable: true
  }, {
    key: 'contextTypes',
    value: {
      closeMenuHandler: _propTypes2['default'].func
    },
    enumerable: true
  }, {
    key: 'propTypes',
    value: {
      children: _propTypes2['default'].node,
      className: _propTypes2['default'].string,
      icon: _propTypes2['default'].node,
      onClick: _propTypes2['default'].func,
      selected: _propTypes2['default'].bool,
      showIcon: _propTypes2['default'].bool,
      style: _propTypes2['default'].object
    },
    enumerable: true
  }, {
    key: 'defaultPropTypes',
    value: {
      selected: false,
      style: {}
    },
    enumerable: true
  }]);

  return Item;
})(_react.Component);

exports['default'] = Item;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./lib/components/menu/item.js
// module id = 332
// module chunks = 0